import styled from 'styled-components';

interface StyledContainerProps {
  isBetweenOperator?: boolean;
}

export default styled.div<StyledContainerProps>`
  display: flex;
  flex-direction: ${(props) => (props.isBetweenOperator ? 'column' : 'row')};
  gap: 6px;
  
  .number-input-wrapper {
    width: 100%;
  }
  
  .se-between-inputs {
    display: flex;
    align-items: center;
    gap: 6px;
    
    .range-input-wrapper {
      flex: 1;
      min-width: 0;
    }
  }
`;
